import BVSelectComponent from './index.vue'

// const DictSelect = {
//   install: function (Vue) {
//     Vue.component('DictSelect', DictSelectComponent)
//   }
// }

export default BVSelectComponent
